module.exports = __webpack_public_path__ + "static/smoke-10a66660b3e774c985fda662fc33b3e7.svg";